import { Error422 } from "@store/index";
import { notification } from "antd";

interface PerformMutationArgs {
    mutation: () => Promise<any>;
    successMessage: string;
    errorMessage: string;
    formFieldsSetter?: (error: Error422) => void;
    formFieldsResetter?: Function;
    onSuccessCallback?: Function;
    onErrorCallback?: Function;
}

export const performMutation = async (mutationArgs: PerformMutationArgs) => {
    try {
        await mutationArgs.mutation();
        notification.success({
            message: "Success!",
            description: mutationArgs.successMessage,
            placement: "top"
        });
        mutationArgs.onSuccessCallback && mutationArgs.onSuccessCallback();
    } catch (error: any) {
        if (error.status === 403) {
            notification.error({
                message: "Error!",
                description: mutationArgs.errorMessage + ": " + error.data.message,
                placement: "top"
            });
        } else {
            notification.error({
                message: "Error!",
                description: mutationArgs.errorMessage,
                placement: "top"
            });
        }
        if (error.status === 422) {
            mutationArgs.formFieldsSetter && mutationArgs.formFieldsSetter(error.data);
        } else {
            mutationArgs.formFieldsResetter && mutationArgs.formFieldsResetter();
        }
        mutationArgs.onErrorCallback && mutationArgs.onErrorCallback();
    }
};
